import Vue from 'vue'

// 防止重复提交1.0
const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
				el.disabled = true;
				let text = el.innerText;
				el.innerText = "请稍候...";
				el.style="cursor: not-allowed";
                setTimeout(() => {
					el.disabled = false;
					el.innerText = text;
					el.style="cursor: auot";
                }, binding.value || 3000)
            }
        })
    }
});
// 防止重复提交2.0
let texts,itm=-1;
const notClick = Vue.directive('notClick', {
    inserted: function (el, binding) {
		texts = el.innerText;
	},
	update:function (el,binding){
		if(binding.value){
			// clearTimeout(itm)
			// itm = setTimeout(() => {
				el.disabled = false;
				// el.innerText = texts;
				el.style="cursor: auot";
			// }, 3000)
		}else{
				el.disabled = true;
				// el.innerText = "请稍候...";
				el.style="cursor: not-allowed";
		}
	}
});
export { preventReClick , notClick}